import { Component, ElementRef, Input, OnInit, viewChild } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";

import { EventTypes } from "src/app/core/constants/event-types";
import { DateTimeService } from "src/app/core/services/date-time.service";
import {
  CreateContactCommand,
  CustomField,
  CustomFieldTypes,
  GenderType,
  UpdateContactCommand,
} from "../../../../core/api/models";
import { ContactsService } from "../../../../core/api/services/contacts.service";
import { RegularExpressions } from "../../../../core/constants/regular-expressions";
import { BaseFormPageComponent } from "../../../shared/base/components/base-form-page.component";
import { CommonModule } from "@angular/common";
import { BaseFormModule } from "src/app/shared/components/base/base-component/base-form.module";
import { DeleteContactByCellPhoneComponent } from "../delete-contact-by-cellphone/delete-contact-by-cellphone.component";

@Component({
    selector: "app-contacts-form",
    templateUrl: "./contacts-form.component.html",
    styleUrls: ["./contacts-form.component.scss"],
    imports: [BaseFormModule, DeleteContactByCellPhoneComponent]
})
export class ContactsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  pageVocabs = "pages.contacts.form.";

  readonly summaryElement = viewChild<ElementRef>("summary");

  model: CreateContactCommand = {};

  get genderType() {
    return GenderType;
  }

  @Input() phonebookId: number;
  @Input() phonebookTitle: string;
  @Input("customFields") input_customFields: CustomField[] = [];

  get CustomFieldTypes() {
    return CustomFieldTypes;
  }

  customFields: any[] = [];
  deletePhonebookIdsModel: Array<number> = [];

  //#endregion

  constructor(protected currentService: ContactsService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.getCustomFields();
  }

  initForm() {
    this.form = new FormGroup({
      phonebook: new FormControl(this.phonebookTitle),
      firstName: new FormControl(""),
      lastName: new FormControl(""),
      address: new FormControl(""),
      email: new FormControl("", [Validators.email]),
      cellPhone: new FormControl("", [
        Validators.required,
        Validators.pattern(RegularExpressions.globalMobileNumbersForContact),
      ]),
      telephone: new FormControl("", [
        Validators.pattern(RegularExpressions.justNumber),
      ]),
      job: new FormControl(""),
      gender: new FormControl(""),
      customField: new FormControl(),
      phonebookIds: new FormControl(),
      // customFields: new FormArray([])
    });
    try {
      this.form.controls["phonebook"].disable();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  initModel() {
    this.model = {};
    super.initModel();
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateContactCommand) {
    this.unSubs();
    this.loading = true;
    try {
      model.phonebookId = this.phonebookId;
      if (this.deletePhonebookIdsModel?.length > 0) {
        this.model.deleteContactsFromPhonebooksByCellPhoneInput = {};
        this.model.deleteContactsFromPhonebooksByCellPhoneInput.phonebookIds =
          this.deletePhonebookIdsModel;
      } else
        this.model.deleteContactsFromPhonebooksByCellPhoneInput = undefined;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }

    this.currentService
      .contactsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateContactCommand) {
    this.unSubs();

    this.loading = true;
    model.phonebookId = this.phonebookId;

    this.currentService
      .contactsUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  getCustomFields() {
    try {
      this.input_customFields = this.input_customFields.sort(
        (fieldType1, fieldType2) => fieldType1.fieldType - fieldType2.fieldType
      );
      if (!this.model?.customFields) this.model.customFields = [];
      if (!this.input_customFields || this.input_customFields?.length == 0)
        return;

      this.customFields = Object.assign([], this.input_customFields);

      //for edit mode
      if (this.model?.customFields?.length > 0) {
        this.customFields?.forEach((customField) => {
          this.model?.customFields?.forEach((item) => {
            if (customField.nameEn === item.nameEn) {
              switch (item.fieldType) {
                case CustomFieldTypes.Boolean:
                  customField.value = item.value === "true" ? true : false;
                  break;
                case CustomFieldTypes.Integer || CustomFieldTypes.Float:
                  customField.value = item.value ? +item.value : 0;
                  break;
                default:
                  customField.value = item.value;
                  break;
              }
            }
          });
        });
      }

      //اگر فیلدسفارشی وجود داشت منوشا باز کن
      const summaryElement = this.summaryElement();
      if (summaryElement) summaryElement.nativeElement.click();
      this.customFields?.forEach((field) => {
        const control = new FormControl(null);
        this.form?.addControl("customField-" + field.nameEn, control);
        if (field.fieldType == CustomFieldTypes.Integer) {
          this.form
            .get("customField-" + field.nameEn)
            .setValidators(
              Validators.pattern(RegularExpressions.justIntegerNumbers)
            );
        } else if (field.fieldType == CustomFieldTypes.Float)
          this.form
            .get("customField-" + field.nameEn)
            .setValidators(
              Validators.pattern(RegularExpressions.justDecimalNumbers)
            );
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  convertMobile() {
    // this.model.cellPhone = this.model.cellPhone
    //   .convertMobileNumberPrefixTo98()
    //   .trim();
    // this.form.get('cellPhone').updateValueAndValidity();
  }

  // convert custom fields to base model
  setCustomFieldsForModel() {
    try {
      if (this.customFields?.length === 0) return;
      this.model.customFields = this.customFields.map((item) => {
        let value;

        switch (item.fieldType as CustomFieldTypes) {
          case CustomFieldTypes.Boolean:
            value = !item?.value ? "false" : "true";
            break;
          case CustomFieldTypes.Integer || CustomFieldTypes.Float:
            value = item?.value ? item?.value?.toString() : "0";
            break;
          case CustomFieldTypes.Datetime:
            value = DateTimeService.toUTC(item?.value);
            break;
          default:
            value = item?.value?.toString();
            break;
        }
        return {
          fieldType: item?.fieldType,
          nameEn: item?.nameEn,
          nameFa: item?.nameFa,
          value: value,
        };
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onSubmit() {
    if (!this.isValidForm(this.form, this.tagName)) return;
    if (this.loading) return;
    this.setCustomFieldsForModel();
    this.checkCreateOrUpdate();
  }

  onReset() {
    try {
      this.initModel();
      this.customFields.forEach((field) => {
        field.value = "";
      });
      if (this.formPageConfig.isEditMode) {
        this.getCustomFields();
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }
}
